import { useQuery } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getCalculatorInfos, getTransparencyCalculatorInfos } from '@/infra/services'

export const useGetCalculatorInfos = (locale: string = 'es') =>
  useQuery([StorageKey.CALCULATOR_INFO, locale], {
    queryFn: () => getCalculatorInfos(locale),
    enabled: !!locale,
    staleTime: Infinity,
    keepPreviousData: true
  })

export const useGetTransparencyCalculatorInfos = (locale: string = 'es') =>
  useQuery([StorageKey.TRANSPARENCY_CALCULATOR_INFO, locale], {
    queryFn: () => getTransparencyCalculatorInfos(locale),
    enabled: !!locale,
    staleTime: Infinity,
    keepPreviousData: true
  })
